import Utils from "../utils/utils.js";
import EventTracker from "../event_tracking/index.js";
import MarketingCard from "../marketing_card/index.js";
import LogHelper from "../utils/logHelper.js";
import HtmlHelper from "../utils/HtmlHelper.js";

import PagePlugin from "../page_plugin/index.js";
import FloatingMenu from "../floating_menu";

const utilsHelper = new Utils();
const htmlHelper = new HtmlHelper();
export default class ViewService {
  constructor(config, container_id, is_debug, storage_key) {
    this.config = config;
    this.container_id = container_id;
    this.is_debug = is_debug;
    this.storage_key = storage_key;
    this.logHelper = new LogHelper(
      config.LOG_LEVEL,
      config.LOG_ENDPOINT,
      is_debug,
      container_id
    );
    this.retry_time = 5;
    this.floating_menu = null
    this.original_head = null
    this.original_body = null

    try {
      let event_uuid = "";
      if (window.crypto) {
        event_uuid = window.crypto.randomUUID();
      } else {
        event_uuid = utilsHelper.getUUID();
      }

      let ss_event_uuid = sessionStorage.getItem("opt99-event-uuid");
      if (!ss_event_uuid) {
        sessionStorage.setItem("opt99-event-uuid", event_uuid);
      }
    } catch (error) {
      console.log("create-uuid-error", error);
    }
  }

  async start() {
    try {
      let that = this;
      const query_string = window.location.search;
      const url_params = new URLSearchParams(query_string);

      const preview_view_id = url_params.get("opt99_preview");
      const opt99_auth_token = url_params.get("opt99_auth_token");
      const opt99_c_id = url_params.get("opt99_c_id");
      const opt99_preview_type = url_params.get("opt99_preview_type");
      const vid = url_params.get("vid");
      const is_edit = url_params.get("opt99_edit");
      const specific_view = url_params.get("specific_view");
      const platform = this.checkPlatform();
      if (is_edit === "true") {
        return;
      }

      try {
        if (!window.is_opt99_anmation_loaded) {
          await htmlHelper.loadAnimationResources(false);
        }
      } catch (error) {
        console.log("load-error", error);
      }

      // 是預覽的話，強迫顯示特定的view而已
      if (opt99_auth_token && opt99_c_id === this.container_id) {
        this.preview(preview_view_id, opt99_auth_token, opt99_preview_type);
        return;
      }

      // 分一下是哪種瀏覽
      // 1. 不管怎麼樣，一定要顯示現在已經發布且有符合規則的 優先
      let clid = utilsHelper.getClidByContainerId(this.storage_key);
      let device = utilsHelper.detectDeviceByWindowSize();
      let data = {
        url: decodeURIComponent(decodeURIComponent(window.location.href)),
        container_id: this.container_id,
        clid: clid,
        device: device,
        specific_view: specific_view ? specific_view : "",
      };

      // 暫存原有的更新狀態
      const old_site_update_at = sessionStorage.getItem('site_update_at') || ''

      const view_data = await utilsHelper.callAPI(
          "",
          "POST",
          this.config.API_ENDPOINT + "/view/optimize/v2",
          data,
          false,
          true,
      )

      // 儲存新的更新狀態
      sessionStorage.setItem('site_update_at', view_data.headers.get('x-site-update-at'))

      this.logHelper.send({
        level: "info",
        stage: "optimize_view_get_views",
        request_payload: data,
        response_payload: view_data,
        clid: clid,
        api_url: this.config.API_ENDPOINT + "/view/optimize",
      });

      // 取外掛的數據
      let params = this.getPluginIds(view_data);
      params["url"] = decodeURIComponent(
        decodeURIComponent(window.location.href)
      );
      params["container_id"] = this.container_id;
      const value_data = await utilsHelper.callAPI(
        "",
        "POST",
        this.config.API_ENDPOINT + "/view/plugin/render",
        params
      );
      console.log("value_data", value_data);

      if (platform === 'shopline' && !window.app) {
        const ready = await waitUntil(() => !!window.app, this.retry_time);
        if (!ready) return;
      }

      try {
        this.original_head = document.head.outerHTML
        this.original_body = document.body.outerHTML
      } catch (error) {
        console.log('get_original_html_error', error)
      }

      // if (window.fbq && !window.fbq.instance) {
      //   const ready = await waitUntil(() => !!window.fbq.instance, this.retry_time);
      //   if (!ready) return;
      // }

      // 衝動外掛優先
      try {
        await this.initPluginURLView(
          view_data.data.url_view,
          "normal",
          value_data.data,
          vid
        );
      } catch (error) {
        console.log("init_plugin_error", error);
      }

      // 顯示改過的區塊
      this.replaceContent(view_data.data.views, preview_view_id);

      // callback給加入購物車
      let eventTracker = new EventTracker(
        this.container_id,
        this.config,
        this.is_debug,
        this.storage_key
      );
      eventTracker.abTestCallback(view_data.data.views, view_data.data.clid);

      // 紀錄這次的clid 和product對應看過哪些view
      this.recordView(view_data);

      this.initPlugin(view_data, "normal", value_data.data);

      // 比對 session storage 存的 container config's update time 和新的一不一樣, 不一樣的話表示內容有更新再打 API 拿新的
      const new_site_update_at = sessionStorage.getItem('site_update_at')
      let container_config_list = JSON.parse(sessionStorage.getItem('container_config')) || {}
      if (old_site_update_at !== new_site_update_at) {
        // Get this container all config
        const res = await utilsHelper.callAPI('', 'GET', `${that.config.API_ENDPOINT}/view/siteconfig?container_id=${this.container_id}`)
        container_config_list = res.data || {}
        sessionStorage.setItem('container_config', JSON.stringify(container_config_list))
      }

      // mount Floating Menu
      if (container_config_list.floatingmenu?.length && container_config_list.floatingmenu[0].add_column) {
        const floating_menu_info = container_config_list.floatingmenu[0]
        const floating_menu_config = JSON.parse(floating_menu_info.add_column)
        if (url_params.get('mode') === 'preview' && floating_menu_config || floating_menu_info.activate && floating_menu_config) {
          await this._mountFloatingMenu(floating_menu_config)
        }
      }

      // 之後預覽的即時更新都放這
      if (url_params.get('mode') === 'preview') {
        window.addEventListener('focus', async () => {
          // 移除舊的元件
          this.floating_menu = null
          document.querySelector('[data-id="floating_menu"]')?.remove()
          // 掛載新元件
          const res = await utilsHelper.callAPI('', 'GET', `${that.config.API_ENDPOINT}/view/siteconfig?container_id=${this.container_id}`)
          if (res.code === 200) {
            if (res.data.floatingmenu?.length && res.data.floatingmenu[0].add_column) {
              const new_config = JSON.parse(res.data.floatingmenu[0].add_column)
              await this._mountFloatingMenu(new_config)
            }
          }
        })
      }

      // 之後預覽的即時更新都放這
      if (url_params.get('mode') === 'preview') {
        window.addEventListener('focus', async () => {
          // 移除舊的元件
          this.floating_menu = null
          document.querySelector('[data-id="floating_menu"]').remove()
          // 掛載新元件
          const res = await utilsHelper.callAPI('', 'GET', `${that.config.API_ENDPOINT}/view/siteconfig?container_id=${this.container_id}`)
          if (res.code === 200) {
            const new_config = JSON.parse(res.data.floatingmenu[0].add_column)
            await this._mountFloatingMenu(new_config)
          }
        })
      }

      // 行銷圖卡最後啟用
      try {
        // 行銷圖卡
        let marketingCard = new MarketingCard(
          this.container_id,
          this.config,
          this.is_debug,
          this.storage_key
        );
        setTimeout(() => {
          marketingCard.run(window.location.href);
        }, 1000);
      } catch (error) {
        logHelper.send({
          level: "error",
          stage: "global_catch_marketingCard",
          error_trace: {
            error_message: error.message,
            error_stack: error.stack,
          },
        });
      }
    } catch (error) {
      this.logHelper.send({
        level: "error",
        stage: "optimize_view_run_error",
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
        },
      });
      // throw Error(error)
    }
  }

  async recordView(view_data) {
    let container_storage = {
      clid: "",
      view_product: {},
    };
    try {
      let tmp_container_storage = JSON.parse(
        localStorage.getItem(this.storage_key)
      );
      if (tmp_container_storage) {
        container_storage = tmp_container_storage;
      }
    } catch (error) {
      this.logHelper.send({
        level: "error",
        stage: "optimize_record_view_error",
        request_payload: container_storage,
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
          view_data: view_data,
          storage_key: this.storage_key,
          container_storage: localStorage.getItem(this.storage_key),
        },
      });
    }

    try {
      let that = this;
      let views = view_data.data.views;
      let target_clid = "";
      try {
        if (view_data.data.clid) {
          target_clid = view_data.data.clid;
        }
      } catch (error) {
        this.logHelper.send({
          level: "error",
          stage: "optimize_record_view_error",
          request_payload: container_storage,
          error_trace: {
            error_message: error.message,
            error_stack: error.stack,
            view_data: view_data,
          },
        });
        target_clid = "";
      }

      // 記clid
      if (target_clid) {
        container_storage["clid"] = target_clid;
        container_storage["clid_created_at"] = new Date().getTime();
      }

      const platform = this.checkPlatform();

      switch (platform) {
        case "shopline":
          if (!window.app) {
            for (let idx = 0; idx <= this.retry_time; idx++) {
              console.log("not_exist");
              await utilsHelper.sleep(2000);
              if (!window.app) {
                continue;
              }
              container_storage = this.recordShoplineViewMapper(
                container_storage,
                views,
                target_clid
              );
              break;
            }
          } else {
            console.log("exist");
            container_storage = this.recordShoplineViewMapper(
              container_storage,
              views,
              target_clid
            );
          }
          break;
        case "cyberbiz":
          container_storage = this.recordCyberbizViewMapper(
            container_storage,
            views,
            target_clid
          );
          break;
        case "91app":
          container_storage = this.recordNineyiViewMapper(
            container_storage,
            views,
            target_clid
          );
          break;
      }

      console.log("optimize99_container_storage", container_storage);
      localStorage.setItem(this.storage_key, JSON.stringify(container_storage));

      views.forEach(function (view) {
        that.logHelper.send({
          level: "info",
          view: view.view.vid,
          stage: "optimize_seen_view",
          request_payload: container_storage,
          response_payload: view_data,
          clid: container_storage["clid"],
          api_url: that.config.API_ENDPOINT + "/view/optimize",
        });
      });
    } catch (error) {
      this.logHelper.send({
        level: "error",
        stage: "optimize_record_view_error",
        request_payload: container_storage,
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
        },
      });
    }
  }

  replaceContent(views, preview_view_id) {
    console.log("replaceContent_1", views);
    let that = this;
    views.forEach(async function (view) {
      console.log("view.exp_add_column_1", view.exp_add_column);
      if (view.view.vid !== preview_view_id) {
        console.log("view.exp_add_column_2", view.exp_add_column);
        if (view.exp_add_column) {
          let add_column = JSON.parse(view.exp_add_column);
          console.log("add_column", add_column);
          if (add_column.remove_hash_tag === true) {
            let new_url = window.location.pathname + window.location.search;
            let tmp = { tmp: "1" };
            console.log("new_url", new_url);
            history.replaceState(tmp, "", new_url);
          }
        }
        try {
          // 分新版和舊版
          // 新版

          let sdk_ref_ele_tags = [];
          let bk_record_tags = [];
          if (view.view.warm_pc !== "string" && view.view.warm_pc) {
            let sdk_history_files = JSON.parse(view.view.pc_js);
            let sdk_historys = [];
            for (let idx = 0; idx < sdk_history_files.length; idx++) {
              try {
                let result = await utilsHelper.getFile(
                  `https://pic.optimize99.com/api/img/${sdk_history_files[idx]}`
                );
                result = JSON.parse(result);
                sdk_historys = sdk_historys.concat(result);
                console.log("sdk-read-result", result);
              } catch (error) {
                console.log("sdk-read-error", error);
              }
            }
            for (let i = 0; i < sdk_historys.length; i++) {
              const data = sdk_historys[i];

              const isLast = i === sdk_historys.length - 1;

              let sdk_update_result = await htmlHelper.updateSelectedElement(
                document,
                data,
                "next",
                view.view.vid,
                "sdk",
                false,
                isLast // 傳遞是否為最後一筆
              );

              console.log("sdk_update_result-1", sdk_update_result);
              sdk_ref_ele_tags.push(sdk_update_result.ref_ele_tag);
            }
            bk_record_tags = JSON.parse(view.view.warm_pc);
          } else {
            if (view.view.pc_js) {
              let datas = JSON.parse(view.view.pc_js);
                for (const data of datas) {
                let sdk_update_result = await htmlHelper.updateSelectedElement(
                  document,
                  data,
                  "next",
                  view.view.vid,
                  "sdk"
                );
                sdk_ref_ele_tags.push(sdk_update_result.ref_ele_tag);
                console.log("sdk_update_result-2", sdk_update_result);
                bk_record_tags.push(data.original_info.nodeName);
              }
            }
          }

          let check_result = htmlHelper.checkTagModify(
            sdk_ref_ele_tags,
            bk_record_tags
          );
          console.log("view-check_result", check_result);
          that.notifyAlert(view.view.vid, check_result);          
        } catch (error) {
          console.log("error", error);
        }
      }
    });
  }

  async preview(view_id, token, preview_type) {
    if (preview_type === "page_plugin") {
      this.previewPlugin(token);
      return;
    }

    const view_data = await utilsHelper.callAPI(
      "",
      "GET",
      this.config.API_ENDPOINT + `/view/preview?vid=${view_id}&token=${token}`
    );

    console.log("preview_view_data", view_data);
    let data = view_data.data;
    if (!data) {
      return;
    }

    try {
      // 分新版和舊版
      // 新版
      let sdk_ref_ele_tags = [];
      let bk_record_tags = [];
      if (data.warm.pc !== "string" && data.warm.pc) {
        let sdk_history_files = JSON.parse(data.campaign.pc);
        let sdk_historys = [];
        for (let idx = 0; idx < sdk_history_files.length; idx++) {
          try {
            let result = await utilsHelper.getFile(
              `https://pic.optimize99.com/api/img/${sdk_history_files[idx]}`
            );
            result = JSON.parse(result);
            sdk_historys = sdk_historys.concat(result);
            console.log("sdk-read-result", result);
          } catch (error) {
            console.log("sdk-read-error", error);
          }
        }
        for (let i = 0; i < sdk_historys.length; i++) {
          const data = sdk_historys[i];
          const isLast = i === sdk_historys.length - 1;
          let sdk_update_result = await htmlHelper.updateSelectedElement(
            document,
            data,
            "next",
            view_id,
            "sdk",
            false,
            isLast
          );
          console.log("sdk_update_result-3", sdk_update_result);
          sdk_ref_ele_tags.push(sdk_update_result.ref_ele_tag);
        }
        bk_record_tags = JSON.parse(data.warm.pc);
      }
      // 舊版
      else {
        if (data.campaign.pc) {
          let steps = JSON.parse(data.campaign.pc);
          console.log("steps", steps);
          for (const step of steps) {
            let sdk_update_result = await htmlHelper.updateSelectedElement(
              document,
              step,
              "next",
              view_id,
              "sdk"
            );
            console.log("sdk_update_result-4", sdk_update_result);
            sdk_ref_ele_tags.push(sdk_update_result.ref_ele_tag);
            bk_record_tags.push(step.original_info.nodeName);
          };
        }
      }

      console.log("bk_record_tags", bk_record_tags);
      console.log("sdk_ref_ele_tags", sdk_ref_ele_tags);

      let check_result = htmlHelper.checkTagModify(
        sdk_ref_ele_tags,
        bk_record_tags
      );
      this.notifyAlert(view_id, check_result);
    } catch (error) {
      console.log("preview_error:", error);
    }

    let plugin_data = {
      data: {
        views: [
          {
            plugin: {
              online_user: data.online_user,
              sales_counter: data.sales_counter,
            },
          },
        ],
      },
    };

    this.initPlugin(plugin_data, "preview");
  }
  async previewPlugin(token) {
    const result = await utilsHelper.callAPI(
      "",
      "GET",
      this.config.API_ENDPOINT + `/view/urlpreview?token=${token}`
    );
    console.log("result:", result);
    let plugin_data = result.data;
    await this.initPluginURLView(plugin_data);
  }

  checkPlatform() {
    let platform = "unknown";
    do {
      let is_shopline = document.querySelector("link[href*='shoplineapp.com']");
      if (is_shopline) {
        platform = "shopline";
        break;
      }

      let is_cyberbiz = window.CYBERBIZ;
      if (is_cyberbiz) {
        platform = "cyberbiz";
        break;
      }

      let is_91app = window.nineyi;
      if (is_91app) {
        platform = "91app";
        break;
      }
    } while (0);

    return platform;
  }

  recordShoplineViewMapper(container_storage, views, clid) {
    try {
      if (!container_storage) {
        container_storage = {
          view_product: {},
          clid: clid,
        };
      }

      // 建立哪些商品看過哪些view的紀錄
      if (
        window.location.href.includes("/products/") ||
        window.location.href.includes("/categories/")
      ) {
        // 取商品id建立對應看了哪些view對應商品的mapper
        // 商品單頁和商品列表頁一起做
        let product = null;
        let products = [];

        for (let idx = 0; idx < window.app._invokeQueue.length - 1; idx++) {
          let param = window.app._invokeQueue[idx];
          if (param[1] !== "value") {
            continue;
          }

          if (param[2][0] === "product") {
            product = param[2][1];
            continue;
          }

          if (param[2][0] === "products") {
            products = param[2][1];
            continue;
          }
        }

        if (product) {
          if (!container_storage.view_product) {
            container_storage.view_product = {};
          }

          if (!container_storage.view_product[product._id]) {
            container_storage.view_product[product._id] = {};
          }

          for (let idx = 0; idx < views.length; idx++) {
            if (
              !container_storage.view_product[product._id][views[idx].view.vid]
            ) {
              container_storage.view_product[product._id][views[idx].view.vid] =
                {};
            }
            container_storage.view_product[product._id][views[idx].view.vid][
              "last_view_at"
            ] = new Date().getTime();
          }
        }

        for (let idx = 0; idx < products.length; idx++) {
          let tmp_product = products[idx];

          // 商品單頁的的情形不做，因爲這些相關商品在最下方卻不能直接加入購物車
          // 會直接跳到該商品的頁面
          if (Object.keys(tmp_product).length > 2) {
            break;
          }

          if (!container_storage.view_product) {
            container_storage.view_product = {};
          }

          if (!container_storage.view_product[tmp_product.id]) {
            container_storage.view_product[tmp_product.id] = {};
          }

          for (let idx = 0; idx < views.length; idx++) {
            if (
              !container_storage.view_product[tmp_product.id][
                views[idx].view.vid
              ]
            ) {
              container_storage.view_product[tmp_product.id][
                views[idx].view.vid
              ] = {};
            }
            container_storage.view_product[tmp_product.id][views[idx].view.vid][
              "last_view_at"
            ] = new Date().getTime();
          }
        }
      }
    } catch (error) {
      this.logHelper.send({
        level: "error",
        stage: "optimize_recordShoplineViewMapper_error",
        response_payload: views,
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
          container_storage: container_storage,
        },
      });
    }

    return container_storage;
  }

  recordCyberbizViewMapper(container_storage, views, clid) {
    if (!container_storage) {
      container_storage = {
        view_product: {},
        clid: clid,
      };
    }

    try {
      // 分是一頁式還是一般商品頁
      if (window.location.href.includes("/events/")) {
        let btns = Array.from(document.querySelectorAll(".add-button"));
        if (btns.length === 0) {
          btns = Array.from(document.querySelectorAll(".cart-button"));
        }
        let products = btns.map(function (btn) {
          let product = {
            id: btn.getAttribute("data-id"),
          };
          return product;
        });

        for (let idx = 0; idx < views.length; idx++) {
          products.forEach(function (product) {
            if (!container_storage.view_product) {
              container_storage.view_product = {};
            }

            if (!container_storage.view_product[product.id]) {
              container_storage.view_product[product.id] = {};
            }
            if (
              !container_storage.view_product[product.id][views[idx].view.vid]
            ) {
              container_storage.view_product[product.id][views[idx].view.vid] =
                {};
            }
            container_storage.view_product[product.id][views[idx].view.vid][
              "last_view_at"
            ] = new Date().getTime();
          });
        }
      } else if (window.location.href.includes("/products/")) {
        let product = window.c12t.product;

        if (!container_storage.view_product) {
          container_storage.view_product = {};
        }

        if (!container_storage.view_product[product.id]) {
          container_storage.view_product[product.id] = {};
        }

        for (let idx = 0; idx < views.length; idx++) {
          if (
            !container_storage.view_product[product.id][views[idx].view.vid]
          ) {
            container_storage.view_product[product.id][views[idx].view.vid] =
              {};
          }
          container_storage.view_product[product.id][views[idx].view.vid][
            "last_view_at"
          ] = new Date().getTime();
        }
      }
    } catch (error) {
      console.log("error", error);
      this.logHelper.send({
        level: "error",
        stage: "optimize_recordCyberbizViewMapper_error",
        response_payload: views,
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
          container_storage: container_storage,
        },
      });
    }

    return container_storage;
  }

  recordNineyiViewMapper(container_storage, views, clid) {
    console.log("yo");
    if (!container_storage) {
      container_storage = {
        view_product: {},
        clid: clid,
      };
    }

    try {
      let path = window.location.pathname.toLocaleUpperCase();
      if (path.includes("/SALEPAGE/INDEX/")) {
        let url_product_id = path.replace("/SALEPAGE/INDEX/", "");
        let ele_product_id = document.querySelector(
          'div[ng-bind="SalePageIndexCtrl.SalePageId"]'
        ).innerText;
        let product_id = "";
        if (url_product_id !== ele_product_id) {
          product_id = ele_product_id;
        } else {
          product_id = url_product_id;
        }

        // console.log('container_storage',container_storage)

        if (!container_storage.view_product) {
          container_storage.view_product = {};
        }

        if (!container_storage.view_product[product_id]) {
          container_storage.view_product[product_id] = {};
        }

        for (let idx = 0; idx < views.length; idx++) {
          if (
            !container_storage.view_product[product_id][views[idx].view.vid]
          ) {
            container_storage.view_product[product_id][views[idx].view.vid] =
              {};
          }
          container_storage.view_product[product_id][views[idx].view.vid][
            "last_view_at"
          ] = new Date().getTime();
        }
      }
    } catch (error) {
      console.log("error", error);
      this.logHelper.send({
        level: "error",
        stage: "optimize_recordNineyiViewMapper_error",
        response_payload: views,
        error_trace: {
          error_message: error.message,
          error_stack: error.stack,
          container_storage: container_storage,
        },
      });
    }

    return container_storage;
  }

  async initPluginURLView(plugin_data, from, value_data, preview_vid) {
    const that = this;
    const device_type = utilsHelper.checkDevice(window);
    console.log("initPluginURLView_plugin_data:", plugin_data);
    console.log("initPluginURLView_from", from);

    for (let idx = 0; idx < plugin_data.length; idx++) {
      let url_view_setting = plugin_data[idx];
      let vid = `${this.container_id}-${url_view_setting.urv_id}`;
      if (preview_vid === vid) {
        continue;
      }
      try {
        let url_add_column = JSON.parse(url_view_setting.urv_add);
        if (!url_add_column[device_type]) {
          continue;
        }

        let device_steps = url_add_column[device_type];
        console.log("device_steps", device_steps);
        for (const step of device_steps) {
          await htmlHelper.updateSelectedElement(document, step, "next", vid, "sdk")
        }

        let plugin_types = ["online_user", "sales_counter"];
        for (let p_idx = 0; p_idx < plugin_types.length; p_idx++) {
          let plugin_type = plugin_types[p_idx];
          console.log("plugin_type__", plugin_type);
          let plugins = url_view_setting[plugin_type];
          let bk_plugins = JSON.parse(JSON.stringify(plugins));
          console.log("plugins__", plugins);
          plugins = plugins.filter(function (plugin) {
            return JSON.parse(plugin.add_col)["device_type"] === device_type;
          });
          let add_column_key = "add_col";
          plugins.forEach(function (plugin) {
            plugin["view_key"] = "";
            try {
              plugin[add_column_key] = JSON.parse(plugin[add_column_key]);
              plugin["view_key"] = plugin[add_column_key]["view_key"];
            } catch (error) {
              console.log("view_key_error", error);
            }
            plugin["view_id"] = vid;

            let pagePlugin = new PagePlugin(that.container_id);
            let target_ele = pagePlugin.initSetting(
              plugin,
              plugin_type,
              from,
              value_data
            );
            console.log("urlView_find_plugin:", target_ele);
            if (target_ele) {
              pagePlugin.initValue();
              pagePlugin.display();
            }
          });

          bk_plugins.forEach(function (bk_plugin) {
            let id = "";
            if (plugin_type === "sales_counter") {
              id = bk_plugin.sct_id;
            } else if (plugin_type === "online_user") {
              id = bk_plugin.olu_id;
            }

            let pagePlugin = new PagePlugin(that.container_id);
            pagePlugin.recordViewPlugin(id, "", plugin_type);
          });
        }
      } catch (error) {
        console.log("url_view_add_error", error);
      }
    }
  }

  initPlugin(plugin_data, from, value_data) {
    const that = this;
    console.log("plugin_data_體驗:", plugin_data);
    console.log("from", from);
    // // 體驗ㄉ
    // if (!plugin_data.data.vid) {
    //     return
    // }

    let views = plugin_data.data.views;
    views.forEach(function (view) {
      let plugin_types = Object.keys(view.plugin);
      for (let idx = 0; idx < plugin_types.length; idx++) {
        let plugin_type = plugin_types[idx];

        view.plugin[plugin_type].forEach(function (plugin_setting) {
          plugin_setting["view_key"] = "";
          let add_column_key = "add_col";
          if (plugin_setting["add_column"]) {
            add_column_key = "add_column";
          }
          if (plugin_setting[add_column_key]) {
            try {
              plugin_setting[add_column_key] = JSON.parse(
                plugin_setting[add_column_key]
              );
              plugin_setting["view_key"] =
                plugin_setting[add_column_key]["view_key"];
            } catch (error) {
              console.log("view_key_error", error);
            }
          }
          let pagePlugin = new PagePlugin(that.container_id);
          let target_ele = pagePlugin.initSetting(
            plugin_setting,
            plugin_type,
            from,
            value_data
          );
          console.log("find_plugin", target_ele);
          if (target_ele) {
            pagePlugin.initValue();
            pagePlugin.display();
          }
          pagePlugin.recordViewPlugin(plugin_setting.id, "", plugin_type);
        });
      }
    });

    // let plugin_types = Object.keys(plugin_data.vid)

    // for (let idx = 0; idx < plugin_types.length; idx++) {
    //     let plugin_type = plugin_types[idx]
    //     if (!plugin_data.vid[plugin_type]) {
    //         continue
    //     }

    //     plugin_data.vid[plugin_type].forEach(function(plugin_setting){

    //         plugin_setting['view_key'] = ''
    //         let add_column_key = 'add_col'
    //         if (plugin_setting['add_column']) {
    //             add_column_key = 'add_column'
    //         }

    //         if (plugin_setting[add_column_key]) {
    //             try {
    //                 plugin_setting[add_column_key] = JSON.parse(plugin_setting[add_column_key])
    //                 plugin_setting['view_key'] = plugin_setting[add_column_key]['view_key']
    //             } catch (error) {
    //                 console.log('view_key_error', error)
    //             }
    //         }
    //         let pagePlugin = new PagePlugin(that.container_id)
    //         let target_ele = pagePlugin.initSetting(plugin_setting, plugin_type, from)
    //         console.log('find_plugin', target_ele)
    //         if (target_ele) {
    //             pagePlugin.initValue()
    //             pagePlugin.display()
    //         }
    //     })
    // }
  }

  getPluginIds(view_data) {
    console.log("get_plugin_ids:", view_data);
    let params = {};
    // let map_key = {}
    let views = view_data.data.views;
    let url_views = view_data.data.url_view;

    let plugin_types = ["sales_counter"];
    let plugin_field_mapper = {
      sales_counter: {
        id: "sct_id",
      },
    };

    plugin_types.forEach(function (plugin_type) {
      params[`${plugin_type}_id`] = [];
      views.forEach(function (view) {
        let plugin = view.plugin;
        plugin[plugin_type].forEach(function (plugin_setting) {
          params[`${plugin_type}_id`].push(plugin_setting.id);

          // try {
          //     let add_column = JSON.parse(plugin_setting.add_column)
          //     let key = `${view_id}`
          // } catch (error) {

          // }
        });
      });
    });
    plugin_types.forEach(function (plugin_type) {
      url_views.forEach(function (url_view) {
        url_view[plugin_type].forEach(function (plugin_setting) {
          console.log("plugin_setting", plugin_setting);
          if (plugin_setting.id) {
            params[`${plugin_type}_id`].push(plugin_setting.id);
          } else {
            params[`${plugin_type}_id`].push(
              plugin_setting[plugin_field_mapper[plugin_type].id]
            );
          }
        });
      });
    });

    console.log("id_params:", params);
    return params;
  }

  async notifyAlert(vid, info) {
    let hold = 5;
    if (info.is_clear) {
      console.log("not_need_notify");
      return;
    }

    if (info.fail_count <= hold) {
      console.log("not_need_notify-in-hold");
      return;
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has("specific_view") || urlParams.has("opt99_preview")) {
      console.log("not_need_notify-in-specific-watch");
      return;
    }

    // let not_found_count = 0
    // info.now_tags.forEach(now_tag => {
    //     if (!now_tag) {
    //         not_found_count += 1
    //     }
    // })

    // if (not_found_count <= hold) {
    //     console.log('not_need_notify-in-not-found-count')
    //     return
    // }
    let c_data = "";
    let event_uuid = "";

    try {
      c_data = JSON.parse(localStorage.getItem(this.storage_key));
    } catch (error) {
      console.log("parse-c-data-error", error);
    }
    let ss_event_uuid = sessionStorage.getItem("opt99-event-uuid");
    if (!c_data) {
      if (ss_event_uuid) {
        event_uuid = ss_event_uuid;
      } else {
        try {
          let new_uuid = "";
          if (window.crypto) {
            new_uuid = window.crypto.randomUUID();
          } else {
            new_uuid = utilsHelper.getUUID();
          }
          sessionStorage.setItem("opt99-event-uuid", new_uuid);
          event_uuid = new_uuid;
        } catch (error) {
          console.log("create-new-uuid-error", error);
        }
      }
    } else {
      try {
        event_uuid = c_data.clid;
      } catch (error) {
        console.log("event-id-clid-error", error);
      }
      if (!event_uuid) {
        event_uuid = ss_event_uuid;
      }
    }

    info["clarity"] = false;
    if (window.clarity) {
      info["clarity"] = true;
    }
    info["app"] = false;
    if (window.app) {
      info["app"] = true;
    }
    info["event_uuid"] = event_uuid;
    info["user_agent"] = navigator.userAgent;
    info["trigger_url"] = window.location.href;
    info['html'] = document.querySelector('body').outerHTML
    info['head'] = document.querySelector('head').outerHTML
    info['original_head'] = this.original_head
    info['original_body'] = this.original_body
    if (!info["event_uuid"]) {
      info["event_uuid"] = utilsHelper.getUUID();
      sessionStorage.setItem("opt99-event-uuid", info["event_uuid"]);
    }
    if (info.user_agent.includes('Mozilla/5.0 (Linux; Android 10; K)')) {
      console.log("notify-hold-in-specific-useragent");
      return
    }

    let data = {
      container_id: this.container_id,
      url: window.location.href,
      view_id: vid,
      metadata: info,
    };

    const result = await utilsHelper.callAPI(
      "",
      "POST",
      this.config.API_ENDPOINT + "/view/detect/viewerror",
      data
    );
    console.log("notify-info", data);
    console.log("notify-result", result);
    if (window.clarity) {
      window.clarity("upgrade", "view_error");
      window.clarity("set", "optimize99", "view_error");
      window.clarity("identify", info["event_uuid"], "", "", "");
    }
  }

  async _mountFloatingMenu(floating_menu_config) {
    this.floating_menu = new FloatingMenu()
    await this.floating_menu.createFloatingMenu(document.body)
    this.floating_menu.changeBtnSize(window.innerWidth > 600 ? floating_menu_config.btn_size_pc : floating_menu_config.btn_size_mobile)
    this.floating_menu.changeFloatPosition(floating_menu_config.position)
    this.floating_menu.changeMenuBtnBackground(floating_menu_config.menu_btn_background)
    this.floating_menu.settingToTopFloat(floating_menu_config.to_top_btn)
    for (const float of floating_menu_config.custom_floats) {
      this.floating_menu.addFloat()
      await this.floating_menu.editFloat(float)
    }
  }

  async waitUntil(conditionFn, retryTimes = 5, interval = 1000) {
    for (let i = 0; i <= retryTimes; i++) {
      if (conditionFn()) {
        return true;
      }
      console.log("not_exist");
      await utilsHelper.sleep(interval);
    }
    return conditionFn(); // 最後再確認一次
  }
}
